import React from "react";
import classNames from "classnames";
import Modal from "components/base/Modal";
import css from "./style.scss";
import DialerLogo from "../../../assets/images/Dialer-Logo.svg";
import CloseIcon from "../../../assets/images/iconClose.svg";

const BatchDialerModal = ({ isOpen, onClose }) => {

    const handleConnectToApi = () => {
        try {
            localStorage.setItem("scrollToIntegrations", "1");
        } catch (e) {
            console.warn("localStorage not available", e);
        }

        window.open("/accountnew/landing", "_blank", "noopener,noreferrer");
        if (onClose) onClose();
    };

    const handleCreateBatchAccount = () => {
        window.open("https://app.batchdialer.com/signin", "_blank", "noopener,noreferrer");
    };

    return (
        <Modal
            isOpen={isOpen}
            onClose={onClose}
            isCloseButton={false}
            uniqId="push-to-BatchDialer"
            borderRadius="12px"
            modalClassName={css.pushtoBatchDialerModal}
            className={classNames(css.clsAccPageModals, css.clsBillingModal)}
        >
            <div className={css.modalContainer}>

                <div className={css.spacer}>
                    <div
                        aria-label="close"
                        className={css.closeBtn}
                        onClick={onClose}
                    >
                        <img src={CloseIcon} alt="close icon" className={css.closeIcon} />
                    </div>
                    <div className={css.content}>
                        <div className={css.logoWrap}>
                            <img src={DialerLogo} alt="BatchDialer logo" className={css.logo} />
                        </div>

                        <h3 className={css.headertxt}>Seamlessly Connect to BatchDialer</h3>

                        <p className={css.subtxt}>
                            Push your property leads straight into a BatchDialer campaign and
                            start dialing in minutes.
                        </p>

                        <div className={css.actions}>
                            <button className={classNames(css.btn, css.primary)} type="button"
                                onClick={handleConnectToApi}
                            >
                                Connect to API
                            </button>

                            <button className={classNames(css.btn, css.secondary)} type="button"
                                onClick={handleCreateBatchAccount}
                            >
                                Create BatchDialer Account
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </Modal>
    );
};

export default BatchDialerModal;